// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V9-a","left":"styles_left__2Wr84"};